import { FC } from 'react'
import { AnimatePresence, Variants, motion } from 'framer-motion'

import { CloseBtn, Modal } from './styled'

const variants: { [f: string]: Variants } = {
  modal: {
    initial: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        when: 'afterChildren',
      },
    },
  },
  image: {
    initial: {
      opacity: 0,
      translateX: 50,
    },
    enter: {
      opacity: 1,
      translateX: 0,
      transition: {
        type: 'tween',
        duration: 0.5,
      },
    },
    exit: {
      opacity: 0,
      translateX: -50,
      transition: {
        type: 'tween',
        duration: 0.2,
      },
    },
  },
}

export const ImageDetail: FC<{ url: string; onClose: () => void }> = ({
  url,
  onClose,
}) => (
  <AnimatePresence>
    {url ? (
      <Modal
        variants={variants.modal}
        initial="initial"
        animate="enter"
        exit="exit"
      >
        <motion.img src={url} alt="" variants={variants.image} />
        <CloseBtn onClick={onClose} />
      </Modal>
    ) : null}
  </AnimatePresence>
)
